import { NotificationsMenu } from "~/features/navigation/components/Notifications/NotificationsMenu";
import { Permission, userHasPermission } from "~/domains/user/utils/permissions";
import { useSimpleMenuState } from "~/common/components/Menu/Menu";
import { useSelector } from "react-redux";
import { selectNewNotificationAmount } from "~/features/notifications/redux/NotificationsSelectors";
import { useTranslation } from "react-i18next";
import { PersonalNavItem } from "~/features/navigation/components/headerMenu/PersonalNavItem";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";

export const NotificationNavItem = () => {
  const { t } = useTranslation();
  const [isOpenNotifications, handleClickNotifications, handleCloseNotifications, anchorElNotifications] =
    useSimpleMenuState();

  const newNotificationAmount = useSelector(selectNewNotificationAmount);

  if (!userHasPermission(Permission.SEE_NOTIFICATIONS)) {
    return null;
  }

  return (
    <li className="scha__personal-nav__list__item">
      <PersonalNavItem
        name={t("header.link.my.notification")}
        data-test-id={"header-btn-notification"}
        icon={<NotificationsOutlinedIcon />}
        badgeContent={newNotificationAmount}
        isActive={isOpenNotifications}
        onClick={handleClickNotifications}
        data-ta-spec={"bell-icon"}
        data-ta-total={newNotificationAmount}
        isNotification
      />
      <NotificationsMenu
        open={isOpenNotifications}
        anchorEl={anchorElNotifications}
        onClose={handleCloseNotifications}
      />
    </li>
  );
};
